export const PRICE_REFRESH_DEBOUNCE_MS = 400;
export const PRICE_REFRESH_CLOSED_DEBOUNCE_MS = 900;

interface PriceRefreshOptions {
  refresh: () => void;
  delayMs?: number;
  closedDelayMs?: number;
}

export interface PriceRefresh {
  priceChanged: (checkoutIsOpen: boolean) => void;
  checkoutOpened: () => void;
  cancel: () => void;
}

export function createPriceRefresh({
  refresh,
  delayMs = PRICE_REFRESH_DEBOUNCE_MS,
  closedDelayMs = PRICE_REFRESH_CLOSED_DEBOUNCE_MS,
}: PriceRefreshOptions): PriceRefresh {
  let timer: ReturnType<typeof setTimeout> | null = null;

  function cancel(): void {
    if (timer === null) return;

    clearTimeout(timer);
    timer = null;
  }

  function run(): void {
    cancel();
    refresh();
  }

  return {
    priceChanged(checkoutIsOpen: boolean): void {
      cancel();
      timer = setTimeout(run, checkoutIsOpen ? delayMs : closedDelayMs);
    },

    checkoutOpened(): void {
      if (timer !== null) run();
    },

    cancel,
  };
}
